import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../../carta/services';
import { CartaCreateDishProdSelectPage } from '../../../carta/carta-create/carta-create-dish-prod-select/carta-create-dish-prod-select';
import { Globals } from '../../../../globals';
import { CartasMenusListPage } from '../../cartas-menus-list/cartas-menus-list';
import { CartaCreateSelectTypePage } from '../../../carta/carta-create/carta-create-select-type/carta-create-select-type';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { CartaCreateSelectTemplatePage } from '../../../carta/carta-create/carta-create-select-template/carta-create-select-template';
import { CartaViewSimulatorPage } from '../../../carta/carta-view/carta-view-simulator/carta-view-simulator';

/**
 * Generated class for the CartaMenuViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'component-carta-view',
    templateUrl: 'component-carta-view.html',
})
export class ComponentCartaViewPage implements OnInit {

    @Input() state: string = "view";
    @Input() uid_element: string = "";
    @ViewChild('enlacesContainer') enlacesContainer: ElementRef;
    total_views = 0;
    total_shares = 0;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private cartaServices: CartaServices,
        public globals: Globals,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public http: HttpClient) {
    }

    ngOnInit() {
        // Limpiar valores anteriores
        this.total_views = 0;
        this.total_shares = 0;

        // Ejecutar getViewsShares si uid_element está disponible
        if (this.uid_element) {
            this.getViewsShares();
        }

        //al hacer cualquier click cambiar el estado de "new" a "view"
        const container = this.enlacesContainer.nativeElement;
        container.addEventListener('click', (event) => {
            this.state = "view";
        });
    }

    ngOnDestroy() {
        //al destruir componente cambiar el estado de "new" a "view"
        if (this.state === 'new') {
            this.state = "view";
        }
    }

    createSection() {
        //set vars
        //this.globals.GAtrackView('Cartas', 'Cartas - Section new - Create', this.globals.restaurant.email, 'Create/Update', 'Create section new', 'Cartas', this.cartaServices.carta_tmp.UID);
        this.cartaServices.getIndexOfPage();
        var index = this.globals.objectToArray(this.cartaServices.carta_tmp.pages[0].sections).length;
        //create
        this.navCtrl.push(CartaCreateDishProdSelectPage, {
            update_state: true,
            carta_uid: this.cartaServices.carta_tmp.UID,
            section_index: index,
            page_index: 0,
            section_complete: this.cartaServices.carta_tmp.pages[0].sections,
            section_name: '',
            new_section: true,
            carta_name: this.globals.returnLangCartaMenuCombo(this.cartaServices.carta_tmp),
        });
    }

    editName() {
        this.navCtrl.push(CartaCreateSelectTypePage, {
            update_state: true,
            carta_uid: this.cartaServices.carta_tmp.UID,
            carta_name: this.cartaServices.carta_tmp.name,
            type: this.cartaServices.carta_tmp.template_name,
        });
    }

    editSection(section, index) {
        //set vars
        this.cartaServices.edit_section = section;
        this.cartaServices.edit_index = index;
        this.cartaServices.edit_elements_array = this.globals.objectToArray(this.cartaServices.edit_section.elements);
        this.cartaServices.edit_type = 'element';
        //edit
        this.cartaServices.getIndexOfPage();
        this.navCtrl.push(CartaCreateDishProdSelectPage, {
            update_state: true,
            carta_uid: this.cartaServices.carta_tmp.UID,
            section_index: this.cartaServices.edit_index,
            page_index: this.cartaServices.edit_page_index,
            section_complete: this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections,
            section_name: this.cartaServices.edit_section.name,
            section_name_ca: this.cartaServices.edit_section.name_ca,
            section_name_en: this.cartaServices.edit_section.name_en,
            section_name_it: this.cartaServices.edit_section.name_it,
            section_name_fr: this.cartaServices.edit_section.name_fr,
            section_name_de: this.cartaServices.edit_section.name_de,
            new_section: false,
            carta_name: this.globals.returnLangCartaMenuCombo(this.cartaServices.carta_tmp),
        });
    }

    deleteSection(section, index) {

        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //set vars
                        this.cartaServices.edit_section = section;
                        this.cartaServices.edit_index = index;
                        //delete
                        delete this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections[this.cartaServices.edit_index];
                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = obj_help;
                        this.cartaServices.afs.collection('cartas').doc(this.cartaServices.carta_tmp.UID).update({
                            'pages': this.cartaServices.carta_tmp.pages,
                        });
                        this.cartaServices.edit = false;
                    }
                }
            ]
        });
        alert.present();
    }

    deleteCarta() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-carta'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.cartaServices.valueChanges.unsubscribe();
                        this.cartaServices.afs.doc('cartas/' + this.cartaServices.carta_tmp.UID).delete();
                        //this.globals.GAtrackView('Cartas', 'Cartas - Delete', this.globals.restaurant.email, 'Delete', 'Delete carta', 'Cartas', this.cartaServices.carta_tmp.UID);
                        this.redirect();
                    }
                }
            ]
        });
        alert.present();
    }

    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.setRoot(CartasMenusListPage);
        loadingPopup.dismiss();
    }

    reorderSections(indexes) {
        let element = this.cartaServices.edit_sections[indexes.from];
        this.cartaServices.edit_sections.splice(indexes.from, 1);
        this.cartaServices.edit_sections.splice(indexes.to, 0, element);
    }

    updateSectionOrder() {
        var _obj = {};
        for (var i = 0; this.cartaServices.edit_sections.length > i; i++) {
            _obj[i] = {
                name: this.cartaServices.edit_sections[i].name || '',
                name_ca: this.cartaServices.edit_sections[i].name_ca || '',
                name_de: this.cartaServices.edit_sections[i].name_de || '',
                name_en: this.cartaServices.edit_sections[i].name_en || '',
                name_fr: this.cartaServices.edit_sections[i].name_fr || '',
                name_it: this.cartaServices.edit_sections[i].name_it || '',
                order: this.cartaServices.edit_sections[i].order,
                elements: this.cartaServices.edit_sections[i].elements,
            };
        }
        this.cartaServices.carta_tmp.pages[this.cartaServices.edit_page_index].sections = _obj;
        this.cartaServices.afs.collection('cartas').doc(this.cartaServices.carta_tmp.UID).update({
            'pages': this.cartaServices.carta_tmp.pages,
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    updateOptions() {
        if (this.cartaServices.carta_tmp.digital_app == undefined) {
            this.cartaServices.carta_tmp.digital_app = false;
        }
        if (this.cartaServices.carta_tmp.tk_active == undefined) {
            this.cartaServices.carta_tmp.tk_active = false;
        }
        if (this.cartaServices.carta_tmp.order_share == undefined) {
            this.cartaServices.carta_tmp.order_share = 0;
        }

        this.cartaServices.afs.collection('cartas').doc(this.cartaServices.carta_tmp.UID).update({
            show_enumerate_elements: this.cartaServices.carta_tmp.show_enumerate_elements,
            show_logo: this.cartaServices.carta_tmp.show_logo,
            digital_app: this.cartaServices.carta_tmp.digital_app,
            tk_active: this.cartaServices.carta_tmp.tk_active,
            order_share: this.cartaServices.carta_tmp.order_share
        });

        //toast guardado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    license() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    async getViewsShares() {
        // Validar que el uid_element no esté vacío
        if (!this.uid_element || this.uid_element === '') {
            return;
        }

        const first_date = moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss');
        const last_date = moment().format('YYYY-MM-DD HH:mm:ss');

        const params = new HttpParams()
            .set('rest_uid', this.globals.restaurant_uid)
            .set('first_date', first_date)
            .set('last_date', last_date)
            .set('element_uid', this.uid_element);

        this.http.post(this.globals.analytics_path + 'analytics/total_views_share_element', params, {})
            .subscribe(async response => {
                this.total_views = response['total_views'];
                this.total_shares = response['total_share'];
            }, error => { });
    }

    goToConfigLogo() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.push(ConfigurationImagesPage);
    }

    selectTemplate() {
        this.navCtrl.push(CartaCreateSelectTemplatePage, {
            update_state: true,
            carta_uid: this.cartaServices.carta_tmp.UID,
            type: this.cartaServices.carta_tmp.template_name,
            carta_name: this.globals.returnLangCartaMenuCombo(this.cartaServices.carta_tmp),
        });
    }

    openAnalytica() {
        this.navCtrl.push(CartaViewSimulatorPage, {
            carta_title: this.globals.returnLangCartaMenuCombo(this.cartaServices.carta_tmp)
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/cartas-menus/carta-menu-view/component-carta-view/component-carta-view.ts